module.exports = __webpack_public_path__ + "img/facebook-square-brands.90c1be5e.svg";